import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { GoogleAnalyticsService } from '@core/services/google-analytics.service';
import { MessagingService } from '@core/services/messaging.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfigConstant } from '@shared/constants';
import { FingerPrintService } from '@shared/services/finger-print.service';
import { LoadingService } from '@shared/services/loading.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = ConfigConstant.APP_TITLE;
  Plateform = ConfigConstant.APP_NAME;

  constructor(
    private loadingService: LoadingService,
    private messagingService: MessagingService,
    private fingerPrintService: FingerPrintService,
    private translateService: TranslateService,
    private titleService: Title,
    private googleAnalytics: GoogleAnalyticsService
  ) {}

  ngOnInit(): void {
    this.googleAnalytics.init();
    this.messagingService.requestPermission();
    this.messagingService.receiveMessage();
    this.fingerPrintService.getFingerprint();
    setTimeout(() => {
      this.loadingService.stopLoading();
    }, 100);
    this.updateTitle();
    this.translateService.onLangChange.subscribe(() => {
      this.updateTitle();
    });
  }

  private updateTitle(): void {
    this.translateService.get('shared.Platform').subscribe((title) => {
      this.titleService.setTitle(title);
    });
  }

}
